module.exports = __webpack_public_path__ + "static/maidan-sm-a4d9b0e64a97f2cf1d3c7029395417ea.jpg";